<template>
  <div class="page-content">
    <!-- <p class="newMine_pageTitle">个人信息</p> -->
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">个人信息</span>
    </p>
    <div class="newMine_content">
      <div class="basic_info">
        <p class="basic_title">基本信息</p>
        <el-descriptions :column="1" border>
          <el-descriptions-item label="姓名">{{info.name}}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{info.phone}}</el-descriptions-item>
          <el-descriptions-item label="准考证号">{{info.certiNo}}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{info.idCardNumber}}</el-descriptions-item>
          <!-- <el-descriptions-item label="政治面貌">{{mapType(info.politicStatus,'politi_type')}}</el-descriptions-item> -->
           <el-descriptions-item label="民族">
            <el-select v-model="info.nation" placeholder="请选择" size="mini" clearable filterable>
              <el-option :label="item.label" :value="item.value" v-for="(item,index) in mapT.nation" :key="index"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="政治面貌">
            <el-select v-model="info.politicStatus" placeholder="请选择" size="mini" clearable filterable>
              <el-option :label="item.label" :value="item.value" v-for="(item,index) in mapT.politi_type" :key="index"></el-option>
            </el-select>
          </el-descriptions-item>
           <el-descriptions-item label="户籍类型">
            <el-select v-model="info.registerType" placeholder="请选择" size="mini" clearable filterable>
              <el-option :label="item.label" :value="item.value" v-for="(item,index) in mapT.register_type" :key="index"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="籍贯">
            <el-input v-model="info.nativePlace" placeholder="请输入" size="mini" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="职业">
            <el-select v-model="info.job" placeholder="请选择" size="mini" clearable filterable>
              <el-option :label="item.label" :value="item.value" v-for="(item,index) in mapT.profession" :key="index"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="职位">
            <el-input v-model="info.post" placeholder="请输入" size="mini" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="工作单位">
            <el-input v-model="info.workUnit" placeholder="请输入" size="mini" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="现居住地">
            <el-input v-model="info.contactAddress" placeholder="请输入" size="mini" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="邮编">
            <el-input v-model="info.postalCode" placeholder="请输入" size="mini" clearable></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="basic_info">
        <p class="basic_title">报考信息</p>
        <el-descriptions :column="1" border>
          <el-descriptions-item label="年度码">{{info.ndm}}</el-descriptions-item>
          <el-descriptions-item label="主考学校">{{info.schCode}}-{{info.schName}}</el-descriptions-item>
          <el-descriptions-item label="助学点">{{info.helpName}}</el-descriptions-item>
          <el-descriptions-item label="专业层次">{{mapType(info.eduLevel,'eduLevel')}}</el-descriptions-item>
          <el-descriptions-item label="专业">{{info.specialtyCode}}-{{info.specialtyName}}</el-descriptions-item>
          <el-descriptions-item label="考籍状态">{{mapType(info.status,'student_status')}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div>
        <el-button @click="submit" type="primary" style="margin: 0 0 15px 200px;">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  components: {
  },
  name: "info",
  data () {
    return {
      loading: false,
      info:{},
      mapT:{}
    };
  },
  computed: {
    ...mapState(['user'])
  },
  created () {
    this.getData();
    this.getTypes('politicStatus')
  },
  methods: {
    async getData () {
      this.$http.get('/student/pc/getStudentInfo').then((res) => {
        this.info = res
      })
    },
    getTypes(t){
      this.$http.post('/student/pc/common/getDictItemByTypes',['politi_type','eduLevel','student_status','register_type','nation','profession']).then((res) => {
        this.mapT=res
      })
    },
    mapType(t,m){
      return this.mapT[m]?.find(e=>e.value==t)?.label
    },
    submit(){
      this.$http.put('/student/pc/editInfo',this.info).then((res) => {
        this.$message.success('保存成功')
        this.getData()
      })
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .is-bordered-label {
  width: 150px;
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_content {
  padding: 0 30px;
}

.basic_info {
  margin-bottom: 10px;
}

.basic_title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
}
.el-input {
  width: 193px;
}
</style>
